// third-party
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

// project import
import menu from './menu';
import user from './userSlice';
import notification from './notification';
import dropdowns from './dropdowns';
import selected from './selected';
import notifications from './notifications';
import account from './account';
import profile from './profile';
import ui from './ui';
import utils from './utils';
import feedback from './feedback';
import { baseApi } from 'store/baseApi';

// ==============================|| COMBINE REDUCERS ||============================== //

const persistConfig = {
  key: 'root', // The key to use for storing the data in local storage
  storage, // The storage engine to use for persistence
  whitelist: ['user'] // Array of reducer names to persist
  // Optionally, you can configure blacklist to exclude certain reducers from being persisted
  // blacklist: ['auth'],
};

const appReducer = combineReducers({
  menu,
  user,
  notification,
  notifications,
  dropdowns,
  selected,
  account,
  // vaseelah,
  profile,
  ui,
  utils,
  feedback,
  [baseApi.reducerPath]: baseApi.reducer
});

const persistedReducer = persistReducer(persistConfig, appReducer);

const rootReducer = (state, action) => {
  if (action.type === 'user/logout') {
    state = undefined;
  }

  return persistedReducer(state, action);
};

export default rootReducer;
